import config from '../config';

// ── PHONE & EMAIL SVGs ─────────────────────────────────────────
const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.64a16 16 0 0 0 6 6l1-1a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

// ── CTA BAND ───────────────────────────────────────────────────
// Props:
//   label    – small eyebrow label
//   heading  – big headline
//   text     – subtext paragraph
//   btnLabel – primary button text
//   onAction – function called when button clicked
export default function CtaBand({
  label     = 'Kom igång',
  heading   = 'BEHÖVER DU HJÄLP MED KYLA ELLER VÄRME?',
  text      = 'Ring oss eller fyll i formuläret – vi svarar snabbt med ett ärligt prisförslag. Jourlinje dygnet runt för akuta ärenden.',
  btnLabel  = 'Kontakta oss nu',
  onAction,
}) {
  return (
    <div className="cta">
      <div className="sl">{label}</div>
      <h2>{heading}</h2>
      <p>{text}</p>
      <div className="chips">
        <button className="bp" onClick={onAction}>{btnLabel}</button>
        <a className="chip" href={config.phoneHref}>
          <PhoneIcon />{config.phone}
        </a>
        <a className="chip" href={`mailto:${config.email}`}>
          <EmailIcon />{config.email}
        </a>
      </div>
    </div>
  );
}
